import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/components/ui';

const items = [
  { to: '/', key: 'nav.home', end: true, icon: <path d="M3 10l9-7 9 7v10a2 2 0 01-2 2H5a2 2 0 01-2-2z" /> },
  {
    to: '/zakat',
    key: 'nav.zakat',
    icon: (
      <>
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <path d="M8 6h8M8 11h2M14 11h2M8 15h2M14 15h2M8 19h8" />
      </>
    ),
  },
  { to: '/dons', key: 'nav.donations', icon: <path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 00-7.8 7.8L12 21.2l8.8-8.8a5.5 5.5 0 000-7.8z" /> },
  {
    to: '/apprendre',
    key: 'nav.learn',
    icon: (
      <>
        <path d="M2 4h7a3 3 0 013 3v13a2 2 0 00-2-2H2z" />
        <path d="M22 4h-7a3 3 0 00-3 3v13a2 2 0 012-2h8z" />
      </>
    ),
  },
  {
    to: '/chantiers',
    key: 'nav.jobs',
    icon: (
      <>
        <path d="M2 20h20" />
        <path d="M5 20V10l7-5 7 5v10" />
        <path d="M10 20v-5h4v5" />
      </>
    ),
  },
];

export function BottomNav() {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('nav.label')} className="fixed inset-x-0 bottom-0 z-40 border-t border-sand-200 bg-white pb-safe">
      <ul className="mx-auto grid max-w-2xl grid-cols-5">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn('flex min-h-[60px] flex-col items-center justify-center gap-[3px] pb-1 pt-1.5 text-[11px]', isActive ? 'font-extrabold text-brand-800' : 'font-semibold text-gray-600 hover:text-brand-800')
              }
            >
              {({ isActive }) => (
                <>
                  <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="none" stroke="currentColor" strokeWidth={isActive ? 2 : 1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    {item.icon}
                  </svg>
                  {t(item.key)}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
